export default __webpack_public_path__ + "static/media/element_26.24462644.webp";